import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SearchRestaurants.css';
import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { isNil } from '../../utils/IsNil';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as SearchIcon } from "../../resources/icons/search-v1.svg";
import { ReactComponent as ClearIcon } from "../../resources/icons/close.svg";
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var SearchRestaurants = /*#__PURE__*/memo(function (_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var history = useHistory();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var url = get(fields, 'data.datasource.searchPage.jss.value.href');
  var dictionary = get(fields, 'data.moduleDictionary');
  var placeholderText = getDictionaryItem(dictionary, 'PlaceholderText');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var analyticsButtonClick = function analyticsButtonClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), text);
  };
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('SearchRestaurants component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SearchRestaurants component is empty: please provide data source]");
    }
    return null;
  }
  var goToUrl = function goToUrl() {
    history.push("".concat(url, "?title=").concat(value));
    window.location.reload();

    // window.location.href = `${url}?title=${value}`;
  };
  var handleKeyPress = function handleKeyPress(event) {
    if ((event.key === 'Enter' || event.key === 'NumpadEnter') && value.trim()) {
      analyticsButtonClick(value);
      goToUrl();
    }
  };
  var handleGoClick = function handleGoClick() {
    analyticsButtonClick(value);
    goToUrl();
  };
  var handleCloseClick = function handleCloseClick() {
    setValue('');
  };
  var handleTextInput = function handleTextInput(e) {
    setValue(e.target.value);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input-text-primary input-search-text",
    placeholder: placeholderText,
    onKeyPress: handleKeyPress,
    onChange: handleTextInput,
    value: value
  }), /*#__PURE__*/React.createElement("button", {
    disabled: !value.trim().length,
    onClick: handleGoClick,
    className: "btn-link search-icon"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !!value.trim().length && /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseClick,
    className: "btn-link close-icon"
  }, /*#__PURE__*/React.createElement(ClearIcon, null)));
});
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cyzdz2n";
var ltrStyles = "l14cw4qd";
var rtlStyles = "r1l841tp";
export default SearchRestaurants;